import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import qs from 'qs'
import VueAxios from 'vue-axios'
import upload_common from './common_js/request_common/upload_common.js'
import remove_common from './common_js/request_common/remove_common.js'
import clean from './common_js/request_common/clean.js'
import dialog_close from './common_js/common_mode/dialog_close_func.js'
// 引入 echarts
import * as echarts from 'echarts'


Vue.prototype.qs = qs 


Vue.config.productionTip = false
//解决跨域
Vue.prototype.HOST="/api"
//使用axios
Vue.prototype.$axios=axios
// 使用upload_common
Vue.prototype.$upload_common=upload_common
// 使用remove_common
Vue.prototype.$remove_common=remove_common
// 使用clean内的组件
Vue.prototype.$clean=clean
// 使用dialog_close内的组件
Vue.prototype.$dialog_close=dialog_close

// 全局注册echarts
Vue.prototype.$echarts = echarts


// Vue.use(clean, App, )

//请求在到达服务器之前，先会调用use中的这个回调函数来添加请求头信息
axios.interceptors.request.use(config => {
  //为请求头对象，添加token验证的Authorization字段
  config.headers.Authorization = 'JWT ' + window.sessionStorage.getItem("token")
  return config
})


Vue.use(ElementUI,VueAxios,axios);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
